import { render, staticRenderFns } from "./v-navbar.vue?vue&type=template&id=0e7485b9&scoped=true&"
var script = {}
import style0 from "./v-navbar.vue?vue&type=style&index=0&id=0e7485b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7485b9",
  null
  
)

export default component.exports